export const REDUCER_NAME = "privacyPolicyPopup";

export const ACTION_TYPES = {
  open: `${REDUCER_NAME}/open`,
  close: `${REDUCER_NAME}/close`,
};
